import { ICourseData } from "../typings/ICourse";
import http from "./client";

interface ICoursesByGroupQueryParams {
  group_id: number;
  limit?: number;
  search?: string;
  page?: number;
  onlyAuthor?: boolean;
  searchOnlyName?: boolean;
  sort_by?: string;
  order?: 'asc' | 'desc'
  atpay?: boolean;
}

interface ICoursesByGroupResponse {
  courses: Array<ICourseData>
}

async function coursesByGroup (queryParams: ICoursesByGroupQueryParams): Promise<Array<ICourseData>> {
  const response = await http.get<ICoursesByGroupResponse>('/panel/courses/coursesbygroup', {
    params: queryParams
  });

  return response.data.courses;
}

async function coursesListByAuthor(queryParams: ICoursesByGroupQueryParams) {
  const response = await http.get('/api/course/list-by-author', {
    params: queryParams,
  });
  return response.data;
}

const courses = {
  coursesByGroup, coursesListByAuthor
}

export default courses;